import React from 'react';

const JobCard = ({
  role,
  locations,
  qualifications,
  disciplines,
  experience,
  salary,
  jobDescriptionId,
  expertiseModalId,
  onApply
}) => {
  return (
      <div className="card p-3 mb-3 h-100 w-100 d-flex flex-column">
        <h5>{role}</h5>
        <p>
          <span className="text-danger">
            <i className="bi bi-geo-alt-fill"></i>
          </span>{' '}
          {locations}
        </p>
        <p>
          <span className="text-success">
            <i className="bi bi-mortarboard-fill"></i>
          </span>{' '}
          {qualifications}
        </p>
        <p>
          <span className="text-primary">
            <i className="bi bi-cpu-fill"></i>
          </span>{' '}
          {disciplines}
        </p>
        <p>
          <span className="text-info">
            <i className="bi bi-briefcase-fill"></i>
          </span>{' '}
          {experience}
        </p>
        {salary && (
          <p>
            <span className="text-warning">
              <i className="bi bi-currency-dollar"></i>
            </span>{' '}
            {salary}
          </p>
        )}

        <div className="btn-group mt-auto" role="group" aria-label="Job Action Buttons">
          {/* Job Description Modal Button */}
          <button
            type="button"
            className="btn btn-sm btn-marquee"
            data-bs-toggle="modal"
            data-bs-target={`#${jobDescriptionId}`}
          >
            Job Description
          </button>

          {/* Expertise Modal Button */}
          <button
            type="button"
            className="btn btn-sm btn-orange"
            data-bs-toggle="modal"
            data-bs-target={`#${expertiseModalId}`}
          >
            Expertise
          </button>

          {/* Apply Now */}
          <button
            type="button"
            className="btn btn-sm btn-success pull-right"
            data-bs-toggle="modal"
            data-bs-target="#jobApplyModal"
            onClick={onApply}
          >
            Apply Now
          </button>
        </div>
      </div>
  );
};

export default JobCard;
